import React from 'react';

interface ToggleSwitchProps {
  isActive?: boolean;
  onToggle?: () => void;
  label?: string;
  labelPosition?: 'top' | 'left';
  textSize?: string;
  showStatus?: boolean;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ( {
  isActive = false,
  onToggle,
  label,
  labelPosition = 'left',
  textSize = '',
  showStatus = false,
} ) => {
  return (
    <div
      className={`${
        labelPosition === 'left' ? 'flex items-center justify-between gap-3 w-full' : 'flex flex-col gap-2'
      }`}
    >
      {label && (
        <label
          className={`${textSize} text-gray-700 font-normal cursor-pointer select-none`}
        >
          {label}
        </label>
      )}
      <div className="flex items-center gap-2">
        <button
          onClick={onToggle}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 ${
            isActive ? 'bg-blue-500 focus:ring-blue-500' : 'bg-gray-300 focus:ring-gray-300'
          }`}
          role="switch"
          aria-checked={isActive}
        >
          <span
            className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform duration-200 ease-in-out ${
              isActive ? 'translate-x-5' : 'translate-x-0.5'
            }`}
          />
        </button>
        {showStatus && (
          <span className="text-sm text-gray-600">
            {isActive ? 'Activé' : 'Désactivé'}
          </span>
        )}
      </div>
    </div>
  );
};

export default ToggleSwitch;